<script setup>
import content from './content.html?raw';
import '~/assets/css/guide-fonts.css';
import './homepage.css';
import {mountJournal} from './journal.mjs';
import {mountSignup} from './signup.mjs';
const island=ref(null);let journal,dispose;
onMounted(()=>{journal=mountJournal(island.value);dispose=mountSignup(island.value,journal,$fetch);});
onBeforeUnmount(()=>{dispose?.();journal?.dispose();});
</script>
<template><div ref="island" v-html="content" /></template>
